var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"map-point",class:[
            _vm.small?'small':' ',
            _vm.left?'left':' '
        ],style:(("top:" + _vm.y + "%;left:" + _vm.x + "%;")),attrs:{"to":_vm.url}},[_c('div',{staticClass:"line"},[_c('i')]),_c('span',{staticClass:"text"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }